import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { doc, getDoc } from 'firebase/firestore';

import { usersRef } from '../api/firebase/firestore/user';
import { AuthContext } from '../contexts/auth';
// Import path from 'path';

// 広告主・代理店・媒体社それぞれのページにしか入れないようにRoute
export const TypeOutlet = ({
  children
}: {
  children: JSX.Element;
}): JSX.Element => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      if (currentUser) {
        let currentPage = location.pathname;
        currentPage = currentPage.replace('/main/', '');
        // Mainの直後のpathだけを取得して判断
        currentPage = currentPage.substring(0, currentPage.indexOf('/'));
        let pageType;
        if (currentPage.includes('client')) {
          pageType = 1;
        } else if (currentPage.includes('agent')) {
          pageType = 2;
        } else if (currentPage.includes('publisher')) {
          pageType = 3;
        }
        const userRef = doc(usersRef, currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.data()?.type !== pageType) {
          navigate('/auth/login');
        }
      }
    })();
  }, []);

  return children;
};
